// 下拉选择——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `module/select/index${i + 1}`,
  name: `module/selectIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/select/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 下拉选择——主流程，开始
    ...MainRoutes
  ]
}
